import {
  EsignFieldKind,
  type PublicSignerProgressRequest,
  type PublicSignerSessionResponse
} from '../publicSignerTypes';

import {
  getCheckboxFieldValue,
  getRadioGroupFieldValue,
  getSignatureFieldValue,
  getTextFieldValue,
  isFieldEditable,
  isSignatureEntryField
} from './fieldValue';
import type { PublicSignerFieldDraftValues } from './types';

export function buildPublicSignerFieldSnapshot(
  session: PublicSignerSessionResponse,
  fieldDraftValues: PublicSignerFieldDraftValues
): PublicSignerProgressRequest['fields'] {
  return session.fields.filter(isFieldEditable).map((field) => {
    const draftValue = fieldDraftValues[field.id];

    if (field.field_kind === EsignFieldKind.Checkbox) {
      return {
        field_id: field.id,
        field_kind: EsignFieldKind.Checkbox,
        value: getCheckboxFieldValue(draftValue)
      };
    }

    if (isSignatureEntryField(field)) {
      return {
        field_id: field.id,
        field_kind: field.field_kind,
        value: getSignatureFieldValue(draftValue)
      };
    }

    if (field.field_kind === EsignFieldKind.RadioGroup) {
      return {
        field_id: field.id,
        field_kind: EsignFieldKind.RadioGroup,
        value: getRadioGroupFieldValue(draftValue)
      };
    }

    const nextValue = getTextFieldValue(draftValue);

    return {
      field_id: field.id,
      field_kind: EsignFieldKind.Text,
      value: nextValue.trim() ? nextValue : null
    };
  });
}

export function hasPublicSignerSignatureEntryValue(
  fields: PublicSignerProgressRequest['fields']
) {
  return fields.some(
    (field) =>
      (field.field_kind === EsignFieldKind.Signature ||
        field.field_kind === EsignFieldKind.Initial) &&
      Boolean(field.value)
  );
}
